import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IPollAnswers } from '../../../../../models/poll.model';
import { PollMultipleAbstract } from '../../../../../abstracts/poll-multiple.abstract';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ToastController } from 'ionic-angular';
import { IClientConfig } from '../../../../../models/client.model';
import { has, isEqual } from 'lodash';
import { UtilitiesProvider } from '../../../../../providers/utilities';

@Component({
  selector: 'app-multiple-question',
  templateUrl: 'multiple-question.html'
})

export class MultipleQuestionComponent extends PollMultipleAbstract implements OnInit, OnChanges {

  @Input('clientConfig')
  public clientConfig: IClientConfig;

  @Input('answers')
  public answers: IPollAnswers[]

  @Input('questionId')
  public questionId: string;

  @Input('userAnswer')
  public userAnswer: any;

  @Input('language')
  public language: string;

  @Input('lastQuestion')
  public lastQuestion: boolean;

  @Input('userHasRecord')
  public userHasRecord: boolean;

  public form: FormGroup;

  // Use when rebuild the form happens
  public canShowForm: boolean = true;

  constructor(
    public fb: FormBuilder,
    public toastCtrl: ToastController,
    private utilitiesData: UtilitiesProvider) {
    super(fb, toastCtrl);
  }

  ngOnInit() {
    this.setQuestionId(this.questionId);
    this.getObjectForm(this.answers);
    this.checkAnswers();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (has(changes, 'questionId') && changes.questionId.firstChange === false) {
      this.setQuestionId(this.questionId);
      this.utilitiesData.consoleWarn('Change Question Id', this.questionId);
    }
    if (has(changes, 'answers') && changes.answers.firstChange === false) {
      if (!isEqual(changes.answers.previousValue, changes.answers.currentValue)) {
        this.canShowForm = false;
        this.getObjectForm(this.answers);
        this.canShowForm = true;
      }

      this.utilitiesData.consoleWarn('Change Answers', this.answers);
      this.utilitiesData.consoleWarn('isEqual', isEqual(changes.answers.previousValue, changes.answers.currentValue))
    }
    if (has(changes, 'userAnswer') && changes.userAnswer.firstChange === false) {
      this.patchForm(this.userAnswer);
      this.utilitiesData.consoleWarn('Change userAnswer', this.userAnswer);
    }
  }


  public checkAnswers() {
    if (this.userAnswer) {
      this.patchForm(this.userAnswer);
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/poll/components/poll-questions/multiple-question/multiple-question.ts